import type { FormInputSettingsFormGroupType } from '@components/sp-form-input-settings';
import type { PaymentFormWidgetData } from '@web/widgets/payment-form/type';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import type { WebLegacyWidgetEntity } from '@web/types';
import { TranslateModule } from '@ngx-translate/core';
import { SpFormInputSettingsModule } from '@components/sp-form-input-settings/src/sp-form-input-settings.module';
import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';

@Component({
    selector: 'web-shop-cart-form-input-settings',
    templateUrl: './shop-cart-form-input-settings.component.html',
    styleUrls: ['./shop-cart-form-input-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WebSettingsModule, SpFormInputSettingsModule, TranslateModule],
})
export class ShopCartFormInputSettingsComponent extends WebBaseControlTypedSettingsComponent<FormInputSettingsFormGroupType> {
    @Input() public widget: WebLegacyWidgetEntity<PaymentFormWidgetData>;
}
